export default __webpack_public_path__ + "static/media/chicken.320b652a.png";